import { render, staticRenderFns } from "./CarteraVentas.vue?vue&type=template&id=314c778a&"
import script from "./CarteraVentas.vue?vue&type=script&lang=js&"
export * from "./CarteraVentas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports